import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { EPostureType } from "./enums/posture-type";

export class Task {
    @AutoMap()
    Position!: number;
    @AutoMap()
    Description!: string;    
    @AutoMap()
    StartedOn!: Temporal.PlainDateTime;
    @AutoMap()
    EndedOn!: Temporal.PlainDateTime;
    @AutoMap()
    Posture!: EPostureType
    @AutoMap()
    Repetitif!: boolean


    Color!: string;
    
    public constructor(init?: Partial<Task>) {
        Object.assign(this, init);
    }
}